import React from 'react'

const DataNotFound = () => {
  return (
    <div className="flex justify-center items-center h-[100vh]">
    <h2 className="flex justify-center items-center font-bold"> PAGE NOT FOUND!</h2>
  </div>
  )
}

export default DataNotFound